module.exports = __webpack_public_path__ + "static/media/accountLink.473a43ea.png";